var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LENDI_BOT_IDENTITY } from '../state/types';
export var updateLoading = function (state, action) {
    return __assign(__assign({}, state), { loading: action.payload });
};
export var updateError = function (state, action) {
    return __assign(__assign({}, state), { error: action.payload, loading: false });
};
export var startLendiBotTyping = function (state) {
    var membersWithBotTypingStart = state.members.map(function (mem) {
        return mem.identity === LENDI_BOT_IDENTITY ? __assign(__assign({}, mem), { isTyping: true }) : mem;
    });
    return __assign(__assign({}, state), { members: membersWithBotTypingStart });
};
export var stopLendiBotTyping = function (state) {
    var membersWithBotTypingStop = state.members.map(function (mem) {
        return mem.identity === LENDI_BOT_IDENTITY ? __assign(__assign({}, mem), { isTyping: false }) : mem;
    });
    return __assign(__assign({}, state), { members: membersWithBotTypingStop });
};
//# sourceMappingURL=OtherReducers.js.map